import * as types from '../../types'
import api from '../../api'

export default {
  state: {
    financeRepayDate: '',
    shouldPayMoney: '',
    currentPeroidNotPayMoney: '',
    bankAccountInfo: '',
    balancedPrincipal: '',
    balancedInterest: '',
    balancedFee: '',
    canAdvancedRepay: '',
    shouldPenalty: '',
    period: ''
  },
  getters: {
    [types.GET_WHOLE_REPAY_INFO] (state) {
      return {
        financeRepayDate: state.financeRepayDate,
        shouldPayMoney: state.shouldPayMoney,
        currentPeroidNotPayMoney: state.currentPeroidNotPayMoney,
        bankAccountInfo: state.bankAccountInfo,
        balancedPrincipal: state.balancedPrincipal,
        balancedInterest: state.balancedInterest,
        balancedFee: state.balancedFee,
        canAdvancedRepay: state.canAdvancedRepay,
        shouldPenalty: state.shouldPenalty,
        period: state.period
      }
    }
  },
  mutations: {
    [types.SET_WHOLE_REPAY_INFO] (state, data) {
      state.financeRepayDate = data.financeRepayDate
      state.shouldPayMoney = data.shouldPayMoney
      state.currentPeroidNotPayMoney = data.currentPeroidNotPayMoney
      state.bankAccountInfo = data.bankAccountInfo
      state.balancedPrincipal = data.balancedPrincipal
      state.balancedInterest = data.balancedInterest
      state.balancedFee = data.balancedFee
      state.canAdvancedRepay = data.canAdvancedRepay
      state.shouldPenalty = data.shouldPenalty
      state.period = data.period
    },
    [types.SET_WHOLE_NOT_PAY_MONEY] (state, data) {
      state.currentPeroidNotPayMoney = data
    }
  },
  actions: {
    [types.GET_WHOLE_REPAY_DATA]: ({commit}, params) => api.getWholePeriodRepayInfo(params),
    [types.GET_WHOLE_PERIOD_REPAY_INFO]: ({commit}, params) => api.wholePeriodPayConfirm(params)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/wholeRepay.js